/* @flow */
import React from 'react';
// $FlowIgnore
import moment from 'moment';
import DATE_FORMAT from 'constants/date';
// $FlowIgnore
import { Link } from 'react-router';
import Tr from 'components/UIKit/Table/Tr';
import Td from 'components/UIKit/Table/Td';
import ReleaseButton from 'components/buttons/ReleaseButton';
import { isPermitted } from 'components/Security/permissions';
import ReleaseButtonContainer from 'containers/workflow/ReleaseButtonContainer';

type ProjectsRowProps = {
  children: any,
  router: Object,
};

export default function ProjectsRow({
  children,
  router,
  projectRoles,
  ...props
}: ProjectsRowProps): React.Element {
  let program = children.programs[0].name;
  const isAuthorized = isPermitted(
    projectRoles,
    ['release'],
    children.project_id,
  );

  return (
    <Tr customDataTestID={`row-${children.project_id}`} key={children.project_id}>
      <Td customDataTestID={`button-project-${children.project_id}`}>
        <Link to={`${program}/${children.code}/dashboard`}>
          {children.project_id}
        </Link>
      </Td>
      <Td customDataTestID="text-project-name">{children.name}</Td>
      <Td customDataTestID="text-project-primary-site">{children.primary_site}</Td>
      <Td customDataTestID="text-project-submission-state">
        {(children.request_submission && 'Harmonization Requested') ||
          (children.in_review && 'Review') ||
          'Open'}
      </Td>
      <Td customDataTestID="button-batch-release">
        {children.release_requested ? (
          'Release Requested'
        ) : (
          <ReleaseButtonContainer
            disabled={!children.releasable}
            projectInfo={children}
          />
        )}
      </Td>
      <Td customDataTestID="text-project-release-state">{children.released ? 'Released' : 'Not Released'}</Td>
      <Td customDataTestID="text-project-last-updated">
        {children.last_transaction_datetime
          ? moment(children.last_transaction_datetime).format(DATE_FORMAT)
          : 'Never'}
      </Td>
    </Tr>
  );
}
